import React from 'react';
import { PasswordFormItem } from './Password';

export const InputNewPassword = () => {

    return (
        <>
            <div
                className="title"
                style={{ width: '100%', textAlign: 'center', marginTop: 24, marginBottom: 24 }}
            >
                新しいパスワードを設定してください
            </div>
            <PasswordFormItem />
        </>
    );
}